import { Flex } from "@mantine/core";

import { useDashboardOutstandingPrincipalPerCollection } from "../../../api/hooks/collectionDashboard/useDashboardOutstandingPrincipalPerCollection";
import SectionTitle from "../../../components/Section/SectionTitle/SectionTitle.tsx";
import Table from "../../../components/Table/Table";
import { CollectionDashboardFilter } from "../types.ts";
import { useOspPerBucketTableData } from "./hooks/useOspPerBucketTableData";

interface Props {
  filter: CollectionDashboardFilter;
}

export default function OutstandingPrincipalPerBucket({ filter }: Props) {
  const [{ data, fetching }] =
    useDashboardOutstandingPrincipalPerCollection(filter);

  const [columns, rows] = useOspPerBucketTableData({
    data: data?.dashboardOutstandingPrincipalPerCollection,
  });

  return (
    <Flex direction="column" gap={12}>
      <SectionTitle variant="golden">
        Outstanding Principal per Collection Bucket
      </SectionTitle>
      <Table minWidth="100%" columns={columns} rows={rows} loading={fetching} />
    </Flex>
  );
}
